import { useQuery } from "@tanstack/react-query";
import { RecordPanel } from "@/components/record/RecordFrame";
import { dayLabel, localYmd } from "@/components/record/recordFormat";

interface DealLink { link_id: string; name: string; stage: string | null; status: string | null; created_at: string | null }

/** Deals (the deals table) this buyer is linked to. Most buyers have none, so it hides then. */
export function BuyerDealsPanel({ companyId }: { companyId: string }) {
  const { data = [] } = useQuery<DealLink[]>({
    queryKey: ["company-deals", companyId],
    queryFn: async () => {
      const r = await fetch(`/api/companies/${companyId}/deals`, { credentials: "include" });
      return r.ok ? r.json() : [];
    },
  });
  if (!data.length) return null;
  const today = localYmd(new Date());
  return (
    <RecordPanel title="Deals" count={data.length}>
      <table className="w-full border-collapse text-[12.5px]">
        <thead>
          <tr className="border-b text-left text-[10.5px] uppercase tracking-wider text-muted-foreground">
            <th className="px-2 py-1 font-semibold">Deal</th>
            <th className="px-2 py-1 font-semibold">Stage</th>
            <th className="px-2 py-1 font-semibold">Status</th>
            <th className="px-2 py-1 font-semibold">Added</th>
          </tr>
        </thead>
        <tbody>
          {data.map((d) => (
            <tr key={d.link_id} className="border-b last:border-0">
              <td className="px-2 py-1.5 font-semibold">{d.name}</td>
              <td className="px-2 py-1.5">{d.stage ?? "—"}</td>
              <td className="px-2 py-1.5">{d.status ?? "Active"}</td>
              <td className="whitespace-nowrap px-2 py-1.5 tabular-nums">{dayLabel(d.created_at, today)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </RecordPanel>
  );
}
